import { useState } from 'react';
import { AxiosError } from 'axios';
import { Navigate, useNavigate } from 'react-router-dom';
import { useForm, validators } from '@recargas-dominicanas/core/utils';
import { AuthApi } from '../../api/auth.api';
import { useIsAuth } from '@recargas-dominicanas/core/hooks';

import { 
  Icon, 
  OutlineButton,
  TextField, 
  Title, 
  Error,
  Brand
} from '@recargas-dominicanas/core/components';

import { style } from './login.module.css';

export function Login() {

  const navigate = useNavigate();
  const form = useForm({ username: '', password: '' });
  const [isAuth, isLoading] = useIsAuth('customer');
  const [errorMessage, setErrorMessage] = useState<string>();
  const [showPassword, setShowPassword] = useState(false);

  async function handleLogin() {

    setErrorMessage(undefined);

    if (!form.isValid()) return;

    try {

      const { username, password } = form.value;
      await AuthApi.login(username, password);
      
      navigate('/');

    } catch (err) {

      if (err instanceof AxiosError && err.response?.status === 401) {
        setErrorMessage('Nombre de usuario o contraseña incorrecta');
      } else {
        setErrorMessage('Ocurrio un error al tratar de iniciar sesión');
      }
    }
  }

  if (isLoading) {
    return null;
  }

  if (isAuth) {
    return <Navigate to='/'/>;
  }

  return (
    <div className={style.container}>
      <Brand style={style.brand}/>
      <div className={style.card}>
        <Icon className={style.cardIcon} icon='admin_panel_settings'/>
        <Title style={style.cardTitle} title='Iniciar sesión'/>
        <form className={style.form}>
          <TextField
            style={style.emailField} 
            label='Usuario'
            formField={form.fields.username}
            validators={[
              validators.required
            ]}/>
          <TextField
            style={style.passwordField}
            type={showPassword ? 'text' : 'password'}
            label='Contraseña'
            formField={form.fields.password}
            onEnter={handleLogin}
            validators={[
              validators.required,
              validators.length(4, 'La contraseña debe tener al menos 4 caracteres')
            ]}
            rightIcon={
              <Icon 
                icon={showPassword ? 'visibility' : 'visibility_off'} 
                onClick={() => setShowPassword(show => !show)}/>
            }/>
        </form>
        <Error 
          show={errorMessage !== undefined}
          message={errorMessage!}/>
        <OutlineButton
          style={style.button}
          text='Iniciar sesión'
          onClick={handleLogin}/>
      </div>
    </div>
  );
}
